
<div class="not-found-container">
  <div class="not-found-container2">
    <h3 class="not-found-text2">OOPS! PAGE NOT FOUND</h3>
  </div>

  <div class="not-found-container2">
    <h1 class="not-found-text1" >404</h1>
  </div>
    
    <div class="not-found-container2">
      <h2 class="not-found-text2">
        WE ARE SORRY, BUT THE PAGE YOU REQUESTED WAS NOT FOUND
      </h2>
    </div>
  </div>
  